import React from 'react';
import { TagIcon, ShareIcon } from '@heroicons/react/24/outline';
import { Title, Text } from '@tremor/react';
import CodeCard from '../TextCoder/CodeCard';
import TextCodeCombinationModal from '../TextCoder/TextCodeCombinationModal';
import TextCodeModal from '../TextCoder/TextCodeModal';

const Codebook = ({ textCodes, setUploadAudioModal, handleUpdateCode, handleAddNewCode, t }) => {
    return (
        <div data-testid="codebook-container">
            {/* Header with icon, title and description */}
            <div className="flex items-center space-x-3 mb-4">
                <TagIcon className="h-6 w-6 text-iavisus-100" />
                <Title className="text-lg font-semibold">
                    {t('DetailProjects.Project codes')}
                </Title>
            </div>
            
            <Text className="text-gray-600 mb-6">
                {t('DetailProjects.CodesDescription')}
            </Text>
            {textCodes?.length > 0 ? (
                <div className='flex flex-col gap-4 mt-4' data-testid="codebook-codes-list">
                    {textCodes.filter(code => !code.parent).map((textCode) => (
                        <CodeCard
                            key={textCode.uuid}
                            code={textCode}
                            textCodes={textCodes}
                            setUploadAudioModal={setUploadAudioModal}
                            handleUpdateCode={handleUpdateCode}
                            handleAddNewCode={handleAddNewCode}
                            t={t}
                        />
                    ))}
                    <div className='w-full flex justify-end mt-2 gap-2'>
                        <button className='border border-iavisus-100 bg-white text-iavisus-100 text-sm rounded-md px-4 py-2'
                            data-testid="codebook-join-codes-btn"
                            onClick={() => setUploadAudioModal(
                                <TextCodeCombinationModal
                                    handleClose={() => setUploadAudioModal(null)}
                                    codes={textCodes}
                                    handleCombineCodes={(codesToDelete, newCode) => {
                                        setUploadAudioModal(prev => {
                                            const updatedCodes = prev.filter(code => !codesToDelete.includes(code.uuid));
                                            return [...updatedCodes, newCode];
                                        });
                                    }}
                                />
                            )}>
                            <div className='w-full flex justify-center items-center gap-2 whitespace-nowrap'>
                                <ShareIcon className='w-6 h-6' />
                                {t("DetailProjects.JoinCode")}
                            </div>
                        </button>
                        <button className='border border-iavisus-100 bg-iavisus-100 text-white text-sm rounded-md px-4 py-2'
                            data-testid="codebook-add-code-btn"
                            onClick={() => setUploadAudioModal(
                                <TextCodeModal
                                    handleClose={() => setUploadAudioModal(null)}
                                    handleUpdateCode={handleUpdateCode}
                                    handleAddNewCode={handleAddNewCode}
                                    textCodes={textCodes}
                                />
                            )}>
                            <div className='w-full flex justify-center items-center gap-2 whitespace-nowrap'>
                                <TagIcon className='w-6 h-6' />
                                {t("DetailProjects.Add code")}
                            </div>
                        </button>
                    </div>
                </div>
            ) : (
                <div className='w-full py-12 mt-4 mb-2 rounded-md bg-white p-4 flex flex-col items-center gap-8 flex-grow' data-testid="codebook-empty-state">
                    <div className='text-xl font-bold'>{t('DetailProjects.This project has no codes yet')}</div>
                    <div className='text-base text-gray-500 '>{t('DetailProjects.Add a new code to get started')}</div>
                    <button className='border border-iavisus-100 bg-iavisus-100 text-white text-xl rounded-md px-4 py-2 '
                        type='button'
                        data-testid="codebook-empty-add-code-btn"
                        onClick={() => setUploadAudioModal(<TextCodeModal handleClose={() => setUploadAudioModal(null)} handleUpdateCode={handleUpdateCode} handleAddNewCode={handleAddNewCode} textCodes={textCodes} />)}
                    >
                        <div className='w-full flex justify-center items-center gap-2 whitespace-nowrap'>
                            <TagIcon className='w-6 h-6' />
                            {t("DetailProjects.Add code")}
                        </div>
                    </button>
                </div>
            )}
        </div>
    );
};

export default Codebook;
